import _default from './Container';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Container/index.js
// module id = 648
// module chunks = 0